import { Link2 } from 'lucide-react';

import { PageHeader } from '../../../components/shared';
import { useT } from '../../../i18n';
import { useAuthStore } from '../../../stores/auth';
import { useTenantCuaToi } from '../../auth/hooks/useTenantCuaToi';
import { VAI_TRO_QUAN_TRI_TENANT } from '../../auth/nghiep-vu/quyen-cong-tenant';
import { KhongCoTenant } from '../../nhat-ky/components/KhongCoTenant';
import { DiaChiRieng } from '../../tenant/components/DiaChiRieng';

/**
 * "Địa chỉ truy cập riêng" của cổng tenant — `/he-thong/dia-chi-rieng` (ADR-0097 mục 2, 7): Tenant Admin tự thêm
 * domain của tổ chức, xem bản ghi DNS cần tạo, kiểm DNS, kích hoạt, tạm ngưng, gỡ. Cùng khối với tab Domain ở chi
 * tiết tenant của cổng nền tảng, nơi quản trị nền tảng hỗ trợ.
 *
 * Quyền: role lớp 1 `TENANT_ADMIN`, đúng như API (`/custom-hosts` chỉ mở cho `TENANT_ADMIN` của đúng tenant,
 * tenant-service kiểm), không theo `SECURITY_CONFIG.UPDATE` như Cài đặt bảo mật: người có quyền đó mà không phải
 * quản trị tổ chức sẽ chỉ nhận `403`. Vào được màn (menu mở theo `SECURITY_CONFIG`) mà không phải quản trị tổ chức thì
 * chỉ thấy câu giải thích, không gọi API.
 */
export function DiaChiRiengView() {
  const { t } = useT();
  const { tenantId, dangTai } = useTenantCuaToi();
  // Tài khoản mẫu không có role lớp 1 nên đọc theo nhãn vai trò, như `TheTokenAiToChuc`
  const laQuanTriToChuc = useAuthStore((s) => {
    const u = s.user;
    if (!u) return false;
    return u.vaiTroLop1 ? u.vaiTroLop1.includes(VAI_TRO_QUAN_TRI_TENANT) : u.roles.includes('vaiTro.quanTriToChuc');
  });

  return (
    <div className="flex h-full flex-col bg-subtle">
      <div className="flex-1 space-y-4 overflow-y-auto p-4 pb-12">
        <PageHeader
          breadcrumb={[{ label: t('nav.nhom.cauHinhHeThong') }, { label: t('nav.muc.diaChiRieng') }]}
          titleIcon={<Link2 size={18} className="text-primary-600" />}
          title={t('nav.muc.diaChiRieng')}
        />
        {!tenantId ? (
          dangTai ? null : <KhongCoTenant />
        ) : laQuanTriToChuc ? (
          <DiaChiRieng tenantId={tenantId} duocSua laNenTang={false} />
        ) : (
          <p role="status" className="rounded-lg border border-default bg-surface px-5 py-4 text-sm text-content-secondary">
            {t('diaChiRieng.chiQuanTriToChuc')}
          </p>
        )}
      </div>
    </div>
  );
}
